import { Component, OnInit, Injector } from '@angular/core';
import { ModalService } from '@app/core/ui/modal/modal.service';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent implements OnInit {
  public datas: { message: string };

  constructor(private injector: Injector, private modalService: ModalService) {
    this.datas = this.injector.get('datas');
  }

  ngOnInit() {}

  public cancel(): void {
    this.modalService.cancel();
  }

  public validate(): void {
    this.modalService.validate();
  }
}
